export const DEVICE_SIZE = {
  DESKTOP: "DESKTOP",
  TABLET: "TABLET",
  MOBILE: "MOBILE",
};

export const ANALYTICS_TYPES = {
  FACEBOOK: "FACEBOOK",
  GOOGLE_ANALYTICS: "GOOGLE_ANALYTICS"
};

export const FORM_NAME = {
  REGISTRATION_FORM: "REGISTRATION_FORM",
  CONTACT_US: "CONTACT_US",
  CAREERS:"CAREERS"
};





